import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SideSheetBody } from './SideSheet.Body/SideSheet.Body.es.js';
import { InternalSideSheetContextProvider } from './SideSheet.Context/provider.es.js';
import { SideSheetFooter } from './SideSheet.Footer/SideSheet.Footer.es.js';
import { SideSheetHeader } from './SideSheet.Header/SideSheet.Header.es.js';

const SideSheet = ({ children, ...rest })=>{
    return jsx(InternalSideSheetContextProvider, {
        ...rest,
        children: jsx("div", {
            className: classNames('cb-side-sheet-container'),
            "data-testid": "side-sheet-container",
            children: children
        })
    });
};
SideSheet.Header = SideSheetHeader;
SideSheet.Body = SideSheetBody;
SideSheet.Footer = SideSheetFooter;

export { SideSheet, SideSheet as default };
//# sourceMappingURL=SideSheet.es.js.map
